export const tileServices = {
  roadmap: { id: 'roadmap', name: 'Map', enabled: true, routingService: 'google', type: 'google' },
  terrain: { id: 'terrain', name: 'Terrain', enabled: true, routingService: 'google', type: 'google' },
  satellite: { id: 'satellite', name: 'Satellite', enabled: true, routingService: 'google', type: 'google' },
  hybrid: { id: 'hybrid', name: 'Hybrid', enabled: true, routingService: 'google', type: 'google' },
  rwgps: { id: 'rwgps',
    name: 'RWGPS',
    maxZoom: 18,
    minZoom: 3,
    enabled: true,
    type: 'osm',
    url: '//tile-{s}.ridewithgps.com/rwgps/',
    routingService: 'rwgps',
    attribution: '© OpenStreetMap contributors'
  },
  osm: { id: 'osm',
    name: 'OSM',
    maxZoom: 18,
    minZoom: 3,
    enabled: true,
    type: 'osm',
    url: '//{s}.tile.openstreetmap.org/',
    routingService: 'rwgps',
    attribution: '© OpenStreetMap contributors'
  },
  osmCycle: { id: 'osmCycle',
    name: 'OSM Cycle',
    key: 'a1f31ce03c41486894ffd9ed393ec1ea',
    maxZoom: 18,
    minZoom: 3,
    enabled: true,
    type: 'osm',
    url: '//{s}.tile.thunderforest.com/cycle/',
    routingService: 'rwgps',
    attribution: 'Maps © Thunderforest, Data © OpenStreetMap contributors'
  },
  osmOutdoor: { id: 'osmOutdoor',
    name: 'OSM Outdoor',
    key: 'a1f31ce03c41486894ffd9ed393ec1ea',
    maxZoom: 18,
    minZoom: 3,
    enabled: true,
    type: 'osm',
    url: '//{s}.tile.thunderforest.com/outdoors/',
    routingService: 'rwgps',
    attribution: 'Maps © Thunderforest, Data © OpenStreetMap contributors'
  },
  esriTopo: { id: 'esriTopo',
    name: 'Esri Topo',
    maxZoom: 17,
    minZoom: 3,
    enabled: true,
    type: 'arcgis',
    url: '//server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/',
    mapboxTiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}.png'],
    routingService: 'rwgps',
    attribution: '© Esri'
  },
  usgsTopo: { id: 'usgsTopo',
    name: 'USGS Topo',
    maxZoom: 16,
    minZoom: 3,
    enabled: true,
    type: 'arcgis',
    url: '//basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/',
    mapboxTiles: ['https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}?token='],
    routingService: 'rwgps',
    attribution: '© USGS/ArcGIS'
  },
  usgsTopoLegacy: { id: 'usgsTopoLegacy',
    name: 'USGS Scans',
    maxZoom: 14,
    minZoom: 3,
    enabled: true,
    type: 'arcgis',
    url: '//services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile/',
    mapboxTiles: ['https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}.png'],
    routingService: 'rwgps',
    attribution: '© USGS/ArcGIS'
  }
}
